// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__2YzcD","insightsList":"newBusinessInsightsMenu_insightsList__7-DfA","active":"newBusinessInsightsMenu_active__lEyyv"};